import { resolveLocale } from "@packages/util/locale/localeCookie";
import { messagesAdmGenerics } from "@packages/I18n/admin";
import { messagesAdmCreditManagement } from "@packages/I18n/admin/creditManagement";
import { messagesAdmDataReport } from "@packages/I18n/admin/dataReport";
import { messagesAdmEstablishments } from '@packages/I18n/admin/establishments';
import { messagesAdmMarketingPlan } from "@packages/I18n/admin/marketingPlan";
import { messagesAdmPartners } from "@packages/I18n/admin/partners";
import { messagesAdmSettings } from "@packages/I18n/admin/settings";
import { messagesApi } from "@packages/I18n/api";
import { messagesBusinessHours } from "@packages/I18n/business-hours"
import { messagesCampaigns } from "@packages/I18n/campaigns";
import { messagesConnections } from "@packages/I18n/connections";
import { messagesCoupons } from "@packages/I18n/coupons";
import { messagesError } from "@packages/I18n/error-messages";
import { genericMessages } from "@packages/I18n/generics";
import { messagesIntegration } from "@packages/I18n/integrations";
import { messagesLeads } from "@packages/I18n/leads";
import { messagesLogin } from "@packages/I18n/login";
import { messagesLoginPersonalize } from "@packages/I18n/login-personalize";
import { messagesMarketingGenerics } from "@packages/I18n/marketing";
import { messagesAutomation } from "@packages/I18n/marketing/automation";
import { messagesEmail } from "@packages/I18n/marketing/email";
import { messagesSms } from "@packages/I18n/marketing/sms";
import { messagesMonitoring } from "@packages/I18n/monitoring";
import { messagesOverview } from "@packages/I18n/overview";
import { messagesSettings } from "@packages/I18n/settings";
import { messagesSidebar } from "@packages/I18n/sidebar";
import { messagesSpots } from "@packages/I18n/spots";
import { messagesStatistics } from "@packages/I18n/statistics";
import { messagesSuccess } from "@packages/I18n/success-messages";
import { messagesTrackers } from "@packages/I18n/trackers";
import { messagesTermsOfUse } from "@packages/I18n/usage-terms";
import { messagesUsers } from "@packages/I18n/users";
import { messagesSupport } from "@packages/I18n/support"
import store from "@packages/store";
import Vue from "vue";
import VueI18n from "vue-i18n";
import { messagesVoucher } from "./voucher";
import { messagesSSID } from "./ssid";
Vue.use(VueI18n)

export const messages = {
    pt: {
        message: {

            admDataReport: messagesAdmDataReport.pt,
            admEstablishments: messagesAdmEstablishments.pt,
            admPartners: messagesAdmPartners.pt,
            admGenerics: messagesAdmGenerics.pt,
            admSettings: messagesAdmSettings.pt,
            api: messagesApi.pt,
            automation: messagesAutomation.pt,
            businessHours: messagesBusinessHours.pt,
            campaigns: messagesCampaigns.pt,
            connections: messagesConnections.pt,
            coupons: messagesCoupons.pt,
            creditManagement: messagesAdmCreditManagement.pt,
            email: messagesEmail.pt,
            errorMessages: messagesError.pt,
            generics: genericMessages.pt,
            integrations: messagesIntegration.pt,
            leads: messagesLeads.pt,
            login: messagesLogin.pt,
            loginPersonalize: messagesLoginPersonalize.pt,
            marketingGenerics: messagesMarketingGenerics.pt,
            marketingPlan: messagesAdmMarketingPlan.pt,
            monitoring: messagesMonitoring.pt,
            overview: messagesOverview.pt,
            settings: messagesSettings.pt,
            sidebar: messagesSidebar.pt,
            sms: messagesSms.pt,
            spots: messagesSpots.pt,
            statistics: messagesStatistics.pt,
            successMessages: messagesSuccess.pt,
            termsOfUse: messagesTermsOfUse.pt,
            trackers: messagesTrackers.pt,
            users: messagesUsers.pt,
            voucher: messagesVoucher.pt,
            support: messagesSupport.pt,
            ssid: messagesSSID.pt
        }
    },
    es: {
        message: {
            admDataReport: messagesAdmDataReport.es,
            admEstablishments: messagesAdmEstablishments.es,
            admPartners: messagesAdmPartners.es,
            admGenerics: messagesAdmGenerics.es,
            admSettings: messagesAdmSettings.es,
            api: messagesApi.es,
            automation: messagesAutomation.es,
            businessHours: messagesBusinessHours.es,
            campaigns: messagesCampaigns.es,
            connections: messagesConnections.es,
            coupons: messagesCoupons.es,
            creditManagement: messagesAdmCreditManagement.es,
            email: messagesEmail.es,
            errorMessages: messagesError.es,
            generics: genericMessages.es,
            integrations: messagesIntegration.es,
            leads: messagesLeads.es,
            login: messagesLogin.es,
            loginPersonalize: messagesLoginPersonalize.es,
            marketingGenerics: messagesMarketingGenerics.es,
            marketingPlan: messagesAdmMarketingPlan.es,
            monitoring: messagesMonitoring.es,
            overview: messagesOverview.es,
            settings: messagesSettings.es,
            sidebar: messagesSidebar.es,
            sms: messagesSms.es,
            spots: messagesSpots.es,
            statistics: messagesStatistics.es,
            successMessages: messagesSuccess.es,
            termsOfUse: messagesTermsOfUse.es,
            trackers: messagesTrackers.es,
            users: messagesUsers.es,
            voucher: messagesVoucher.es,
            support: messagesSupport.es,
            ssid: messagesSSID.es
        }
    },
    en: {
        message: {
            admDataReport: messagesAdmDataReport.en,
            admEstablishments: messagesAdmEstablishments.en,
            admPartners: messagesAdmPartners.en,
            admGenerics: messagesAdmGenerics.en,
            admSettings: messagesAdmSettings.en,
            api: messagesApi.en,
            automation: messagesAutomation.en,
            businessHours: messagesBusinessHours.en,
            campaigns: messagesCampaigns.en,
            connections: messagesConnections.en,
            coupons: messagesCoupons.en,
            creditManagement: messagesAdmCreditManagement.en,
            email: messagesEmail.en,
            errorMessages: messagesError.en,
            generics: genericMessages.en,
            integrations: messagesIntegration.en,
            leads: messagesLeads.en,
            login: messagesLogin.en,
            loginPersonalize: messagesLoginPersonalize.en,
            marketingGenerics: messagesMarketingGenerics.en,
            marketingPlan: messagesAdmMarketingPlan.en,
            monitoring: messagesMonitoring.en,
            overview: messagesOverview.en,
            settings: messagesSettings.en,
            sidebar: messagesSidebar.en,
            sms: messagesSms.en,
            spots: messagesSpots.en,
            statistics: messagesStatistics.en,
            successMessages: messagesSuccess.en,
            termsOfUse: messagesTermsOfUse.en,
            trackers: messagesTrackers.en,
            users: messagesUsers.en,
            voucher: messagesVoucher.en,
            support: messagesSupport.en,
            ssid: messagesSSID.en
        }
    },
}


export const i18n = new VueI18n({
    locale: store.getters.locale || resolveLocale(),
    messages,
    silentFallbackWarn: true
});








